import React from 'react'
import { jsonTryParse } from '@ztechapps/common.utils'
import type { ReactJsonViewProps } from 'react-json-view'
import { ClientOnly } from '../ClientOnly'
import { useTheme } from '@ztechapps/common.hook'

export type JsonViewerProps = Omit<ReactJsonViewProps, 'src'> & {
  data: any
}

export const JsonViewer = ({ data, ...rest }: JsonViewerProps) => {
  const [src, setSrc] = React.useState()
  React.useEffect(() => {
    const newData = jsonTryParse(data)
    setSrc(newData)
  }, [data])

  const theme = useTheme()
  const { isDark } = theme.colorMode

  return (
    <ClientOnly
      component={() => import('react-json-view')}
      src={src}
      theme={isDark ? 'monokai' : 'rjv-default'}
      iconStyle="circle"
      collapsed
      name={false}
      enableClipboard={false}
      displayDataTypes={false}
      {...rest}
    />
  )
}
